"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createContext(null);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/cjs/TransitionGroupContext.js
// module id = 304
// module chunks = 0